import { Helmet } from 'react-helmet-async';
import { PurchasingCategoriesView } from '../../../components/dashboard/admin/purchasing-categories';

// ----------------------------------------------------------------------

export default function PurchasingCategories() {
  return (
    <>
      <Helmet>
        <title>Admin Purchasing Categories | Platform Solutions</title>
      </Helmet>
      <PurchasingCategoriesView />
    </>
  );
}
